export const QUOTA_STALE_TIME = 2_000
export const appTitle = 'IsardVDI'
export const isardVdiUrl = 'https://www.isardvdi.com'
export const webSockets = '/socket.io'
